import React, { useState } from "react";
import { motion, useMotionValue } from "framer-motion";
import "./HomeServicesSection.css";
import verifyIcon from "../../../assets/home/services/verifying.png";
import designIcon from "../../../assets/home/services/design.png";


const overlayVariants = {
  rest: { x: "-100%", transition: { duration: 0.3, ease: "linear" } },
  hover: { x: "0%", transition: { duration: 0.3, ease: "linear" } },
};

const contentVariants = {
  rest: { color: "#666", transition: { duration: 0.3 } },
  hover: { color: "#fff", transition: { duration: 0.3 } },
};

const ServiceBox = ({ service, isHovered, onMouseEnter, onMouseLeave, onClick }) => {
  const rotateX = useMotionValue(0);
  const rotateY = useMotionValue(0);

  const handleMouseMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;
    const offsetX = e.clientX - centerX;
    const offsetY = e.clientY - centerY;
    const maxRotate = 10; // maximum rotation angle in degrees
    const newRotateY = (offsetX / (rect.width / 2)) * maxRotate;
    const newRotateX = -(offsetY / (rect.height / 2)) * maxRotate;
    rotateX.set(newRotateX);
    rotateY.set(newRotateY);
  };

  const handleMouseLeave = () => {
    rotateX.set(0);
    rotateY.set(0);
    onMouseLeave();
  };

  return (
    <motion.div
      className="service-box"
      onMouseEnter={onMouseEnter}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      onClick={onClick}
      style={{ rotateX, rotateY }}
      animate={{
        scale: isHovered ? 1.05 : 0.95,
        boxShadow: isHovered
          ? "0px 10px 20px rgba(0, 0, 0, 0.3)"
          : "0px 2px 6px rgba(0, 0, 0, 0.1)",
      }}
      transition={{ duration: 0.3 }}
    >
      <motion.div
        className="service-overlay"
        variants={overlayVariants}
        initial="rest"
        animate={isHovered ? "hover" : "rest"}
      />
      <motion.div
        className="service-content"
        variants={contentVariants}
        initial="rest"
        animate={isHovered ? "hover" : "rest"}
      >
        <div className="service-icon">
          <span className="placeholder-icon">
          <img src={service.image}/>
          </span>
        </div>
        <h3>{service.title}</h3>
        <p>{service.description}</p>
        <motion.button
          className="arrow-button"
          whileHover={{ scale: 1.1 }}
          transition={{ duration: 0.3 }}
        >
          <i className="fas fa-chevron-right"></i>
        </motion.button>
      </motion.div>
    </motion.div>
  );
};

const HomeServicesSection = () => {
  const [fadeOut, setFadeOut] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const services = [
    {
      title: "ASIC Design Services",
      description:
        "Delivering comprehensive ASIC design services, from conceptualization and architecture through to final silicon implementation.",
      link: "/services/asic-design",
      image: designIcon
    },
    {
      title: "ASIC Verification Services",
      description:
        "Ensuring your designs meet exact specifications with our rigorous verification methodologies, enhancing reliability and performance.",
      link: "/services/asic-verification",
      image: verifyIcon
    }
  ];

  return (
    <motion.section
      className={`home-services hs ${fadeOut ? "fade-out" : ""}`}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.7 }}
    >
      {/* Section Heading */}
      <div className="services-heading hs-heading-center">
        <span className="services-subtitle">Our Services</span>
        <h2>
          Advanced ASIC Design &amp; Verification Solutions
          <br />
          Tailored for Your Success
        </h2>
      </div>

      {/* Service Items */}
      <div className="services-items">
        {services.map((service, index) => (
          <ServiceBox
            key={service.title}
            service={service}
            isHovered={hoveredIndex === index}
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
            onClick={() => window.location.assign(service.link)}
          />
        ))}
      </div>
    </motion.section>
  );
};

export default HomeServicesSection;